import { useState, useEffect } from 'react';

import { lottieAnimations } from '@backrs_ui/common-ui';

import { appStrings } from '@backrs_ui/grow-ui/src/assets/appStrings';

import { Box, Theme, SxProps, Typography } from '@mui/material';
import Lottie from 'lottie-react';

const LOADING_MESSAGES = appStrings.modules.officeHours.infoBox.loadingMessages;

export const LoadingAnimation = () => {
  const [loadingMessageIndex, setLoadingMessageIndex] = useState<number>(0);

  // rotate between loading messages
  useEffect(() => {
    const interval = setInterval(() => {
      setLoadingMessageIndex((prev) => (prev + 1) % LOADING_MESSAGES.length);
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  return (
    <Box sx={animationContainerSx}>
      <Lottie animationData={lottieAnimations.webSearch} loop={true} style={animationStyle} />
      <Typography key={loadingMessageIndex} variant="text-md-regular" sx={loadingTextSx}>
        {LOADING_MESSAGES[loadingMessageIndex]}
      </Typography>
    </Box>
  );
};

const animationContainerSx: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  alignSelf: 'center',
  height: '100%',
  width: '100%',
  gap: ({ backrs }) => backrs.spacing['spacing-lg'],
};

const animationStyle: React.CSSProperties = {
  width: '400px',
  maxWidth: '400px',
};

const loadingTextSx: SxProps<Theme> = ({ backrs }) => ({
  color: backrs.colors['Colors/Text/text-secondary'],
  textAlign: 'center',
  animation: 'fadeIn 0.4s ease-in-out',
  '@keyframes fadeIn': {
    '0%': { opacity: 0, transform: 'translateY(8px)' },
    '100%': { opacity: 1, transform: 'translateY(0)' },
  },
});
